import React from 'react';

export interface IVerifiedBadgeProps {
    /** Rendered width/height in px. */
    size?: number;
    className?: string;
    style?: React.CSSProperties;
    title?: string;
}

// Unique gradient id per mounted instance (avoids clashing <defs> ids in the DOM).
let badgeInstanceId = 0;

/**
 * Brand-consistent verification badge: a scalloped "seal" filled with the
 * brand primary colour (via the `--global-primary-color` CSS variable) and a
 * crisp white check on top. Replaces the various ad-hoc verified icons that
 * were scattered around the app (blue Twitter checks, red shields, etc.).
 */
export const VerifiedBadge = (props: IVerifiedBadgeProps) => {
    const { size = 18, className, style, title = 'Verifiziert' } = props;
    const gradientId = React.useMemo(() => `verified-badge-grad-${(badgeInstanceId += 1)}`, []);

    return (
        <svg
            width={size}
            height={size}
            viewBox="0 0 24 24"
            className={className}
            style={{ flexShrink: 0, display: 'inline-block', verticalAlign: 'middle', ...style }}
            role="img"
            aria-label={title}
        >
            <defs>
                <linearGradient id={gradientId} x1="0" y1="0" x2="0" y2="1">
                    <stop offset="0%" style={{ stopColor: 'var(--global-primary-color, #f8588a)', stopOpacity: 0.85 }} />
                    <stop offset="100%" style={{ stopColor: 'var(--global-primary-color, #f31f57)' }} />
                </linearGradient>
            </defs>
            {/* scalloped seal */}
            <path
                d="M23 12l-2.44-2.78.34-3.68-3.61-.82-1.89-3.18L12 3 8.6 1.54 6.71 4.72l-3.61.81.34 3.68L1 12l2.44 2.78-.34 3.69 3.61.82 1.89 3.18L12 21l3.4 1.46 1.89-3.18 3.61-.82-.34-3.68L23 12z"
                fill={`url(#${gradientId})`}
            />
            {/* white check */}
            <path
                d="M10.09 16.72l-3.8-3.81 1.48-1.48 2.32 2.33 5.85-5.87 1.48 1.48-7.33 7.35z"
                fill="#ffffff"
            />
        </svg>
    );
};

export default VerifiedBadge;
